import React from 'react';
import PropTypes from 'prop-types';
import {Card, Grid} from "@mui/material";
import {ReactComponent as WishibamLogo} from "assets/img/wishibam-logo.svg";
import MobileCurrentOrganization from "../components/MobileCurrentOrganization";

MobileSidebarHeader.propTypes = {
    organization: PropTypes.object,
    fixedHeight: PropTypes.string
};

function MobileSidebarHeader({organization = null, fixedHeight = "64px"}) {
    
    return (
        <Card sx={{
            borderRadius: "0px",
            boxShadow: "unset",
            height: fixedHeight,
            position: "sticky",
            top: 0,
        }}>
            <Grid container sx={{height: "100%", padding: "10px 8px 10px 12px"}} alignContent={"center"}>
                <Grid xs={2} container alignContent={"center"} justifyContent={"center"}>
                    {organization?.customIcon ? (
                        <img
                            src={organization.customIcon}
                            alt={'organization logo'}
                            style={{
                                width: '18px',
                                height: '18px',
                                objectFit: 'contain'
                            }}
                        />
                    ) : (
                        <WishibamLogo/>
                    )}
                </Grid>

                <Grid xs={10} item alignContent={"center"}>
                    <MobileCurrentOrganization />
                </Grid>
            </Grid>
        </Card>
    );
}

export default MobileSidebarHeader;